<template>
    <Transition v-if="isLoading"
                name="spinner">
        <div id="cover-spin">
            <span class="loader">
                <span>{{ $spinnerText }}</span>
            </span>
        </div>
    </Transition>

    <v-form :name="props.formProps.formName">
        <Tabs value="0"
              scrollable>

            <TabList class="mb-4">
                <Tab value="0">{{ __('Basic data') }}</Tab>
                <Tab value="1">{{ __('Changelog') }}</Tab>
            </TabList>

            <TabPanels>
                <TabPanel value="0">
                    <div class="grid">
                        <FormCalendar fieldName="operation_date"
                                      label="Operation date"
                                      size="2"
                                      :isFormDisabled="isFormDisabled"
                                      v-model:field="crud.operation_date" />
                        <FormCalendar fieldName="accounting_date"
                                      label="Accounting date"
                                      size="2"
                                      :isFormDisabled="isFormDisabled"
                                      v-model:field="crud.accounting_date" />
                        <FormInputNumber fieldName="amount"
                                         label="Amount"
                                         size="4"
                                         :isFormDisabled="isFormDisabled"
                                         v-model:field="crud.amount" />
                        <FormInputText fieldName="currency"
                                       label="Currency"
                                       size="2"
                                       :isFormDisabled="isFormDisabled"
                                       v-model:field="crud.currency" />
                        <FormInputText fieldName="operation_type"
                                       label="Operation type"
                                       size="2"
                                       :isFormDisabled="isFormDisabled"
                                       v-model:field="crud.operation_type" />
                    </div>
                    <div class="grid">
                        <FormInputText fieldName="transaction_number"
                                       label="Transaction number"
                                       size="3"
                                       :isFormDisabled="isFormDisabled"
                                       v-model:field="crud.transaction_number" />
                        <FormInputText fieldName="instruction_ident"
                                       label="Instruction identificator"
                                       size="3"
                                       :isFormDisabled="isFormDisabled"
                                       v-model:field="crud.instruction_ident" />
                        <FormInputText fieldName="transaction_ident"
                                       label="Transaction identificator"
                                       size="3"
                                       :isFormDisabled="isFormDisabled"
                                       v-model:field="crud.transaction_ident" />
                        <FormInputText fieldName="reference_ident"
                                       label="Reference identificator"
                                       size="3"
                                       :isFormDisabled="isFormDisabled"
                                       v-model:field="crud.reference_ident" />
                    </div>
                    <div class="grid">
                        <FormInputText fieldName="company_bank_account"
                                       label="Company bank account"
                                       size="3"
                                       :isFormDisabled="isFormDisabled"
                                       v-model:field="crud.company_bank_account" />
                        <FormInputText fieldName="contractor_bank_account"
                                       label="Contractor bank account"
                                       size="3"
                                       :isFormDisabled="isFormDisabled"
                                       v-model:field="crud.contractor_bank_account" />
                        <FormInputText fieldName="contractor_name"
                                       label="Contractor name"
                                       size="6"
                                       :isFormDisabled="isFormDisabled"
                                       v-model:field="crud.contractor_name" />
                    </div>
                    <div class="grid">
                        <FormInputText fieldName="transfer_title"
                                       label="Transfer title"
                                       :isFormDisabled="isFormDisabled"
                                       v-model:field="crud.transfer_title" />
                    </div>
                    <div class="grid">
                        <FormTexarea fieldName="additional_info"
                                     label="Additional info"
                                     :isFormDisabled="isFormDisabled"
                                     v-model:field="crud.additional_info" />
                    </div>
                </TabPanel>

                <TabPanel v-if="crud.log"
                          value="1"
                          :pt="{ root: { class: 'form-tab-panel' } }">
                    <ChangeLog :log="crud?.log" />
                </TabPanel>
            </TabPanels>
        </Tabs>

        <div class="grid">
            <FormButtons :formProps="props.formProps"
                         :sourceForm="crud"
                         :validation="validation"
                         :buttonsVisibility="buttonsVisibility"
                         v-model:isFormDisabled="isFormDisabled">
                <template #after-in-edit>
                    <AlertAddButton :addAlert="addAlert" />
                </template>
            </FormButtons>
        </div>
        <AlertAdd :formProps="{ source_table: 'statements', source_id: crud.id, width: '50%' }"
                  v-model:isAddAlertDialogOpen="isAddAlertDialogOpen" />
    </v-form>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';

import FormInputText from '@crud/FormInputText.vue'
import FormInputNumber from '@crud/FormInputNumber.vue'
import FormCalendar from '@crud/FormCalendar.vue'
import FormButtons from '@crud/FormButtons.vue'
import FormTexarea from '@crud/FormTextarea.vue'
import ChangeLog from '@crud/ChangeLog.vue'
import AlertAdd from '@app/Data/Alert/AlertAdd.vue'
import AlertAddButton from '@alert/AlertAddButton.vue'
import { validation, initFormObj } from '@pages/Helper/crud_utils.js'
import { __ } from '@helper/utils.js'

// -----------------------------------------------------

const props = defineProps({
    formProps: Object,
})

const isLoading = ref(true);
const isFormDisabled = ref(true)
const crud = ref({})

const isAddAlertDialogOpen = ref(false);
const buttonsVisibility = ref({})

// -----------------------------------------------------

onMounted(async () => {
    await initFormObj({ props, crud, isLoading, buttonsVisibility })
})

// -----------------------------------------------------

const addAlert = async () => {
    isAddAlertDialogOpen.value = true;
}

// -----------------------------------------------------

</script>

<style lang="scss" scoped></style>
